import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {FormBuilder} from "@angular/forms";
import 'rxjs/Rx';
import {UsuariosService} from './../../seguridad/usuario/recursos/servicios/usuarios.service';
import {UtilConfig} from "../../../../autenticacion/servicios/UtilConfig";
import {LayoutService} from "../../../recursos/servicio/layout.service";

declare const $: any;


const md: any = {
    misc: {
        navbar_menu_visible: 0,
        active_collapse: true,
        disabled_collapse_init: 0,
    }
};

@Component({
    moduleId: module.id,
    selector: 'app-miperfil',
    templateUrl: './view/miperfil.component.html',
    styleUrls: ['./css/miperfil.component.scss'],
    providers: [UsuariosService]

})
export class MiperfilComponent implements OnInit {
//        ╦┌┐┌┬┌┬┐    ┬ ┬  ╔═╗┌─┐┌┐┌┌─┐┌┬┐┬─┐┬ ┬┌─┐┌┬┐┌─┐┬─┐
//        ║││││ │     └┬┘  ║  │ ││││└─┐ │ ├┬┘│ ││   │ │ │├┬┘
//        ╩┘└┘┴ ┴      ┴   ╚═╝└─┘┘└┘└─┘ ┴ ┴└─└─┘└─┘ ┴ └─┘┴└─

    // ITEM DEL CRUD
    // variables de pantalla
    usuarioSession;
    fondo = "fondo1";
    docker;
    authorities = {
        ROLE_USUARIO_LISTAR: false,
        ROLE_CUSTOMER_LISTAR: false,
        ROLE_LOG_SUNAT_LISTAR: false,
        ROLE_REPORTE_LISTAR: false,
        ROLE_INDICADORES_GENERAL: false
    };

    options;
    data;

    constructor(private usuariosService: UsuariosService,
                private route: ActivatedRoute,
                private router: Router,
                private fb: FormBuilder,
                private util: UtilConfig,
                private layoutService: LayoutService) {
        this.usuarioSession = this.util.getCurrentUser();

        // VERIFICA LOS PERMISOS DEL USUARIO LOGEADO
        this.authorities = this.util.verificarAuthorities(this.authorities);
    }

    ngOnInit() {
        // CONSULTAR EL USUARIO QUE ESTA EN LOCALSTORAGE

        // fixed plugin
        const $sidebar = $('.sidebar');
        const $sidebar_img_container = $sidebar.find('.sidebar-background');
        //
        const $full_page = $('.full-page');
        //
        const $sidebar_responsive = $('body > .navbar-collapse');
        const window_width = $(window).width();

        const fixed_plugin_open = $('.sidebar .sidebar-wrapper .nav li.active a p').html();

        if (window_width > 767 && fixed_plugin_open === 'Dashboard') {
            if ($('.fondoBlanco .dropdown').hasClass('show-dropdown')) {
                $('.fondoBlanco .dropdown').addClass('open');
            }

        }

        $('.fondoBlanco a').click(function (event) {
            // Alex: if we click on switch, stop propagation of the event,
            // so the dropdown will not be hide, otherwise we set the  section active
            if ($(this).hasClass('switch-trigger')) {
                if (event.stopPropagation) {
                    event.stopPropagation();
                } else if (window.event) {
                    window.event.cancelBubble = true;
                }
            }
        });

        $('.fondoBlanco .active-color span').click(function () {
            const $full_page_background = $('.full-page-background');

            $(this).siblings().removeClass('active');
            $(this).addClass('active');
            const new_color = $(this).data('color');

            if ($sidebar.length !== 0) {
                $sidebar.attr('data-active-color', new_color);
            }

            if ($full_page.length !== 0) {
                $full_page.attr('filter-color', new_color);
            }

            if ($sidebar_responsive.length !== 0) {
                $sidebar_responsive.attr('data-color', new_color);
            }
        });

        $('.fondoBlanco .background-color span').click(function () {
            $(this).siblings().removeClass('active');
            $(this).addClass('active');
            const new_color = $(this).data('color');

            if ($sidebar.length !== 0) {
                $sidebar.attr('data-background-color', new_color);
            }
        });

        $('.fondoBlanco .img-holder').click(function () {
            const $full_page_background = $('.full-page-background');

            $(this).parent('li').siblings().removeClass('active');
            $(this).parent('li').addClass('active');

            let new_image = $(this).find('img').attr('src');

            if ($sidebar_img_container.length !== 0 && $('.switch-sidebar-image input:checked').length !== 0) {
                $sidebar_img_container.fadeOut('fast', function () {
                    $sidebar_img_container.css('background-image', 'url("' + new_image + '")');
                    $sidebar_img_container.fadeIn('fast');
                });
            }

            if ($full_page_background.length !== 0 && $('.switch-sidebar-image input:checked').length !== 0) {
                const new_image_full_page = $('.fondoBlanco li.active .img-holder').find('img').data('src');

                $full_page_background.fadeOut('fast', function () {
                    $full_page_background.css('background-image', 'url("' + new_image_full_page + '")');
                    $full_page_background.fadeIn('fast');
                });
            }

            if ($('.switch-sidebar-image input:checked').length === 0) {
                new_image = $('.fondoBlanco li.active .img-holder').find('img').attr('src');
                const new_image_full_page = $('.fondoBlanco li.active .img-holder').find('img').data('src');

                $sidebar_img_container.css('background-image', 'url("' + new_image + '")');
                $full_page_background.css('background-image', 'url("' + new_image_full_page + '")');
            }

            if ($sidebar_responsive.length !== 0) {
                $sidebar_responsive.css('background-image', 'url("' + new_image + '")');
            }
        });

        $('.switch-sidebar-image input').change(function () {
            const $full_page_background = $('.full-page-background');
            const $input = $(this);

            if ($input.is(':checked')) {
                if ($sidebar_img_container.length !== 0) {
                    $sidebar_img_container.fadeIn('fast');
                    $sidebar.attr('data-image', '#');
                }

                if ($full_page_background.length !== 0) {
                    $full_page_background.fadeIn('fast');
                    $full_page.attr('data-image', '#');
                }

                const background_image = true;
            } else {
                if ($sidebar_img_container.length !== 0) {
                    $sidebar.removeAttr('data-image');
                    $sidebar_img_container.fadeOut('fast');
                }

                if ($full_page_background.length !== 0) {
                    $full_page.removeAttr('data-image', '#');
                    $full_page_background.fadeOut('fast');
                }

                const background_image = false;
            }
        });

        $('.switch-sidebar-mini input').change(function () {
            const $body = $('body');

            const $input = $(this);

            if (md.misc.sidebar_mini_active === true) {
                $('body').removeClass('sidebar-mini');
                md.misc.sidebar_mini_active = false;

            } else {
                setTimeout(function () {
                    $('body').addClass('sidebar-mini');

                    $('.sidebar .collapse').css('height', 'auto');
                    md.misc.sidebar_mini_active = true;
                }, 300);
            }

            // we simulate the window Resize so the charts will get updated in realtime.
            const simulateWindowResize = setInterval(function () {
                window.dispatchEvent(new Event('resize'));
            }, 180);

            // we stop the simulation of Window Resize after the animations are completed
            setTimeout(function () {
                clearInterval(simulateWindowResize);
            }, 1000);

        });
    }


    togglesDocker(docker) {
        docker.selected = !docker.selected;
        this.util.setDocker(this.docker);
        this.layoutService.actualizarDock();
    }


//        ╔═╗┬ ┬┌┐┌┌─┐┬┌─┐┌┐┌┌─┐┌─┐  ┌─┐┌─┐┬─┐┬  ┬┬┌─┐┬┌─┐┌─┐
//        ╠╣ │ │││││  ││ ││││├┤ └─┐  └─┐├┤ ├┬┘└┐┌┘││  ││ │└─┐ 
//        ╚  └─┘┘└┘└─┘┴└─┘┘└┘└─┘└─┘  └─┘└─┘┴└─ └┘ ┴└─┘┴└─┘└─┘ 


}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/perfil/miperfil/miperfil.component.ts